import {
  Box,
  Chip,
  DialogActions,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Button as ButtonUI,
  CircularProgress,
  Dialog,
  DialogContent,
  Checkbox,
  FormControlLabel
} from '@material-ui/core'

import { useTheme } from '@material-ui/styles'
import CloseIcon from '@material-ui/icons/Close'

import { useDispatch, useSelector } from 'react-redux'

import { Button } from './styles'
import { useState } from 'react'
import { deleteGroupRequest } from 'store/modules/group/actions'
import palette from 'theme/palette'
import { updateUserFromUsersGroupList } from '../../../../store/modules/user/actions'
import {
  updateGroupsFromStoresReport,
  updateStoresFromStoresReport
} from '../../../../store/modules/report/actions'
import api from '../../../../repositories/api'
import { toast } from 'react-toastify'

export const EditGroupModal = ({
  isOpen,
  closeModal,
  groupName,
  setGroupName,
  selectedResponsible,
  setSelectedResponsible,
  selectedStores,
  handleChangeStoreList,
  handleSave,
  groupId
}) => {
  const [isDeleteGroupModalOpen, setIsDeleteGroupModalOpen] = useState(false)
  const [
    isSelectedRemoveResponsibleFromStoresCheckbox,
    setIsSelectedRemoveResponsibleFromStoresCheckbox
  ] = useState(false)
  const [isConfirmEditGroupModalOpen, setIsConfirmEditGroupModalOpen] =
    useState(false)

  const [storesToShowInModal, setStoresToShowInModal] = useState([])
  const [storesToRemoveResponsibleModal, setStoresToRemoveResponsibleModal] =
    useState([])
  const [isDeleteButtonLoading, setIsDeleteButtonLoading] = useState(false)
  const [isSaveButtonLoading, setIsSaveButtonLoading] = useState(false)

  const { groupStoresList, loading } = useSelector(state => state.store)
  const { storesReport } = useSelector(state => state.report)
  const { usersGroupList, user } = useSelector(state => state.user)
  const { groupsFromReport } = useSelector(state => state.group)

  const theme = useTheme()
  const dispatch = useDispatch()

  const token = window.localStorage.getItem('@NeoPro:token')

  const currentGroup = groupsFromReport.find(
    groupFromReport => groupFromReport.groupId === groupId
  )

  const selectedStoreIds = new Set(
    selectedStores.map(selectedStore => selectedStore._id)
  )

  const hasChangedResponsible =
    currentGroup?.supervisor.id !== selectedResponsible.id

  const currentResponsible = usersGroupList.find(
    user =>
      user._id ===
      (hasChangedResponsible
        ? currentGroup?.supervisor.id
        : selectedResponsible.id)
  )

  const handleOpenConfirmDeleteGroupModal = async () => {
    try {
      setIsDeleteButtonLoading(true)
      const response = await api.axios.get(
        `/group/${groupId}/supervisor-removable-stores`
      )
      const availableStoresToRemoveFromBackend = response.data

      const storesToRemoveResponsible = []
      groupStoresList.forEach(store => {
        const currentStore = currentResponsible?.stores.find(
          responsibleStore =>
            responsibleStore.storeId === store._id &&
            responsibleStore.type !== 'owner'
        )

        // checa se existe outro grupo desse mesmo supervisor com essa loja
        // pra então não avisar que será retirada
        if (currentStore) {
          const hasOtherGroupWithSameStore = groupsFromReport.find(
            group =>
              group.stores.find(store => store._id === currentStore.storeId) &&
              group.groupId !== groupId &&
              group.supervisor.id === currentGroup?.supervisor.id
          )

          if (
            !hasOtherGroupWithSameStore &&
            availableStoresToRemoveFromBackend?.includes(currentStore.storeId)
          ) {
            storesToRemoveResponsible.push(currentStore)
          }
        }
      })

      setStoresToRemoveResponsibleModal(storesToRemoveResponsible)
      setIsDeleteGroupModalOpen(true)
      setIsDeleteButtonLoading(false)
    } catch (err) {
      setIsDeleteButtonLoading(false)
      toast.error(err.response?.data?.error?.friendlyMsg || 'Algo deu errado')
    }
  }

  const handleRemoveGroup = () => {
    dispatch(
      deleteGroupRequest(
        user._id,
        groupId,
        isSelectedRemoveResponsibleFromStoresCheckbox,
        token
      )
    )

    const storesToRemoveFromGroups = []

    groupStoresList.forEach(store => {
      const currentStore = currentResponsible?.stores.find(
        responsibleStore => responsibleStore.storeId === store._id
      )
      if (currentStore) {
        const hasOtherGroupWithSameStore = groupsFromReport.find(
          group =>
            group.stores.find(store => store._id === currentStore.storeId) &&
            group.groupId !== groupId
        )

        if (!hasOtherGroupWithSameStore) {
          for (let group of storesReport.groups) {
            const storeToAddStoresReport = group.stores.find(
              groupStore => groupStore._id === store._id
            )
            if (storeToAddStoresReport) {
              storesToRemoveFromGroups.push(storeToAddStoresReport)
              break
            }
          }
        }
      }
    })

    const storesToRemoveOldResponsibleIds = storesToRemoveResponsibleModal.map(
      store => store.storeId
    )
    const filteredStores = currentResponsible.stores.filter(
      store => !storesToRemoveOldResponsibleIds.includes(store.storeId)
    )
    const updatedUser = {
      ...currentResponsible,
      stores: filteredStores
    }

    const updatedStoresFromStoresReport = [
      ...storesReport.stores,
      ...storesToRemoveFromGroups
    ]

    const newGroupsFromStoresReportList = storesReport.groups.filter(
      group => group.groupId !== groupId
    )

    dispatch(updateUserFromUsersGroupList(updatedUser))
    dispatch(updateStoresFromStoresReport(updatedStoresFromStoresReport))
    dispatch(updateGroupsFromStoresReport(newGroupsFromStoresReportList))

    setIsDeleteGroupModalOpen(false)
    setIsSelectedRemoveResponsibleFromStoresCheckbox(false)
    setStoresToRemoveResponsibleModal([])
    closeModal()
  }

  const handleOpenModalToConfirmEditGroup = async () => {
    setIsSaveButtonLoading(true)
    try {
      const response = await api.axios.get(
        `/group/${groupId}/supervisor-removable-stores`
      )

      const availableStoresToRemoveFromBackend = response.data

      const storeToRemoveFromResponsible = []
      groupStoresList.forEach(store => {
        let wasNotRemoved = false
        const currentStore = currentResponsible?.stores.find(
          responsibleStore =>
            responsibleStore.storeId === store._id &&
            responsibleStore.type !== 'owner'
        )

        if (currentStore) {
          if (!hasChangedResponsible) {
            wasNotRemoved = selectedStores.some(
              store => store._id === currentStore.storeId
            )
          }

          const hasOtherGroupWithSameStore = groupsFromReport.find(
            group =>
              group.groupId !== groupId &&
              group.stores.find(store => store._id === currentStore.storeId) &&
              group.supervisor.id === currentGroup?.supervisor.id
          )

          if (
            !(hasOtherGroupWithSameStore || wasNotRemoved) &&
            availableStoresToRemoveFromBackend.includes(currentStore.storeId)
          ) {
            storeToRemoveFromResponsible.push(currentStore)
          }
        }
      })

      const storesToAddToCurrentResponsible = selectedStores.filter(store => {
        const storesFromResponsible = selectedResponsible.stores
        const isCurrentResponsibleInStore = storesFromResponsible.find(
          responsibleStore => responsibleStore.storeId === store._id
        )
        if (!isCurrentResponsibleInStore) {
          return store
        }
      })

      const hasAddedNewStoresToCurrentResponsible =
        storesToAddToCurrentResponsible.length > 0
      const hasRemovedStoresFromOldResponsible =
        storeToRemoveFromResponsible.length > 0

      if (
        hasAddedNewStoresToCurrentResponsible ||
        hasRemovedStoresFromOldResponsible
      ) {
        setStoresToRemoveResponsibleModal(storeToRemoveFromResponsible)
        setStoresToShowInModal(storesToAddToCurrentResponsible)
        setIsConfirmEditGroupModalOpen(true)
        setIsSaveButtonLoading(false)
      } else {
        // Abaixo casos em que
        // - Não alterou responsável
        // - Não precisa adicionar o responsável nas lojas atuais
        // - Não precisa remover o responsável das lojas removidas
        // - Em caso de nenhum dos casos acima, ele apenas salva

        let storesRemovedFromOwner = []
        let storesAddedToOwner = []

        groupStoresList.forEach(store => {
          const currentOwnerStore = currentResponsible?.stores.find(
            responsibleStore =>
              responsibleStore.storeId === store._id &&
              responsibleStore.type === 'owner'
          )
          if (currentOwnerStore) {
            const hasOtherGroupWithSameStore = groupsFromReport.find(
              group =>
                group.groupId !== groupId &&
                group.stores.some(
                  store => store._id === currentOwnerStore.storeId
                )
            )

            const isSelectedStore = selectedStores.some(
              store => store._id === currentOwnerStore.storeId
            )
            // Caso esteja adicionando uma loja em que ele é dono e não tem em nenhuma outra regional
            // Essa loja precisa ser removida da lista de storesReport.stores
            if (!hasOtherGroupWithSameStore && isSelectedStore) {
              // IF para caso o usuário apenas clique em salvar, nenhuma alteração tem que ser feita
              // Se não tiver currentOwnerStore quer dizer que já existia essa loja anteriormente
              if (currentOwnerStore.storeId) {
                storesAddedToOwner.push(currentOwnerStore.storeId)
              }
            }
            // Caso esteja removendo uma loja em que ele é dono e não tem em nenhuma outra regional
            // Essa loja precisa ser adicionada novamente na lista de storesReport.stores
            else if (!(hasOtherGroupWithSameStore || isSelectedStore)) {
              const groupWithCurrentStore = groupsFromReport.find(
                group => group.groupId === groupId
              )
              const storeWithData = groupWithCurrentStore?.stores.find(
                store => store._id === currentOwnerStore.storeId
              )
              // IF para caso o usuário apenas clique em salvar, nenhuma alteração tem que ser feita
              // Se não tiver storeWithData quer dizer que nenhuma loja foi removida
              if (storeWithData) {
                storesRemovedFromOwner.push(storeWithData)
              }
            }
          }
        })

        if (
          storesRemovedFromOwner.length > 0 ||
          storesAddedToOwner.length > 0
        ) {
          dispatch(
            updateStoresFromStoresReport([
              ...storesReport.stores.filter(
                store => !storesAddedToOwner.includes(store._id)
              ),
              ...storesRemovedFromOwner
            ])
          )
        }
        handleSave()
      }
    } catch (err) {
      setIsSaveButtonLoading(false)
      toast.error(err.response?.data?.error?.friendlyMsg || 'Algo deu errado')
    }
  }

  const handleSaveEditGroup = () => {
    // Lojas que precisa ser retiradas do antigo responsável
    const storesToRemoveOldResponsibleIds = storesToRemoveResponsibleModal.map(
      store => store.storeId
    )
    const filteredStoresFromOldResponsible = currentResponsible.stores.filter(
      store => !storesToRemoveOldResponsibleIds.includes(store.storeId)
    )

    const updatedOldResponsible =
      storesToRemoveResponsibleModal.length > 0
        ? {
            ...currentResponsible,
            stores: filteredStoresFromOldResponsible
          }
        : undefined

    // Lojas que precisa ser adicionadas ao novo responsável
    const formattedStores = selectedStores.map(store => ({
      ...store,
      storeId: store._id,
      type: selectedResponsible.stores.some(
        storeFromResponsible =>
          storeFromResponsible.storeId === store._id &&
          storeFromResponsible.type === 'owner'
      )
        ? 'owner'
        : 'manager'
    }))

    const updatedNewResponsible =
      storesToShowInModal.length > 0
        ? {
            ...selectedResponsible,
            stores: [...selectedResponsible.stores, ...formattedStores]
          }
        : undefined

    const formattedStoresIds = formattedStores.map(store => store._id)

    // Checa se alguma loja que estava sem grupo, foi adicionada nesse novo grupo
    // pra assim tirar ela dos storesReport e nao aparecer na tela de lojas como sem grupo
    const storesThatNotHaveGroup = storesReport.stores.filter(
      store => !formattedStoresIds.includes(store._id)
    )

    const allStoresFromGroups = storesReport?.groups
      .map(group => {
        if (group.groupId !== groupId) {
          return group.stores
        }
        return undefined
      })
      .filter(el => el !== undefined)
      .flat(1)

    const allStoresFromGroupsIds = allStoresFromGroups.map(store => store._id)

    // Checa se alguma das lojas que foi removida do antigo responsável pertence à outra regional
    // Para que assim ele não apareça na tabela de Lojas sem Regional
    const removedStores = currentGroup.stores.filter(
      store => !formattedStoresIds.includes(store._id)
    )

    const deletedStoresThatHasNoOtherGroup = removedStores.filter(store => {
      if (
        ![...allStoresFromGroupsIds, ...formattedStoresIds].includes(store._id)
      ) {
        return store
      }
    })

    if (
      storesThatNotHaveGroup.length > 0 ||
      deletedStoresThatHasNoOtherGroup.length > 0
    ) {
      dispatch(
        updateStoresFromStoresReport([
          ...deletedStoresThatHasNoOtherGroup,
          ...storesThatNotHaveGroup
        ])
      )
    }

    handleSave({
      updatedOldResponsible,
      updatedNewResponsible,
      removeSupervisor: isSelectedRemoveResponsibleFromStoresCheckbox
    })

    setStoresToRemoveResponsibleModal([])
    setStoresToShowInModal([])
    setIsConfirmEditGroupModalOpen(false)
    setIsSelectedRemoveResponsibleFromStoresCheckbox(false)
  }

  return (
    <Dialog
      open={isOpen}
      onClose={closeModal}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
      fullWidth
    >
      <DialogTitle style={{ paddingTop: 22 }} disableTypography>
        <Typography style={{ fontSize: '1.25rem', fontWeight: 500 }}>
          Editar Regional
        </Typography>
        <IconButton
          aria-label='close'
          onClick={closeModal}
          style={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              error={false}
              label='Nome'
              value={groupName}
              required
              variant='outlined'
              onChange={event => setGroupName(event.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth variant='outlined'>
              <InputLabel id='responsible'>Responsável</InputLabel>
              <Select
                labelId='responsible'
                name='selectedResponsible'
                label='Responsável'
                autoComplete='off'
                value={
                  usersGroupList.find(
                    user => user._id === selectedResponsible.id
                  ) || ''
                }
                onChange={event =>
                  setSelectedResponsible({
                    ...event.target.value,
                    id: event.target.value._id
                  })
                }
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                  },
                  getContentAnchorEl: null
                }}
              >
                {usersGroupList.map(user => (
                  <MenuItem key={user._id} value={user}>
                    {user.name.complete}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ width: '100%', display: 'flex' }}>
            <FormControl style={{ width: '100%' }} variant='outlined'>
              <InputLabel id='stores'>Lojas</InputLabel>
              <Select
                labelId='stores'
                name='selectedStores'
                label='Lojas'
                multiple
                value={selectedStores}
                onChange={handleChangeStoreList}
                renderValue={selected => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map(value => {
                      return (
                        <Chip
                          style={{ marginRight: 4, marginBottom: 4 }}
                          key={value._id}
                          label={value.name}
                        />
                      )
                    })}
                  </Box>
                )}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                  },
                  getContentAnchorEl: null
                }}
              >
                {groupStoresList.map(store => (
                  <MenuItem
                    key={store._id}
                    value={store}
                    style={{
                      fontWeight: selectedStoreIds.has(store._id)
                        ? theme.typography.fontWeightMedium
                        : theme.typography.fontWeightRegular
                    }}
                  >
                    {store.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        style={{
          paddingLeft: '24px',
          paddingRight: '24px',
          justifyContent: 'space-between'
        }}
      >
        <ButtonUI
          variant='text'
          onClick={handleOpenConfirmDeleteGroupModal}
          disabled={isDeleteButtonLoading || isSaveButtonLoading}
          style={{ color: 'red' }}
        >
          {isDeleteButtonLoading && (
            <CircularProgress size={14} color='inherit' />
          )}
          {!isDeleteButtonLoading && 'EXCLUIR'}
        </ButtonUI>
        <Box>
          <ButtonUI
            variant='text'
            onClick={closeModal}
            disabled={isDeleteButtonLoading || isSaveButtonLoading}
            style={{ marginRight: '18px' }}
          >
            Cancelar
          </ButtonUI>
          <Button
            autoFocus
            onClick={handleOpenModalToConfirmEditGroup}
            disabled={isDeleteButtonLoading || isSaveButtonLoading}
          >
            {isSaveButtonLoading && (
              <CircularProgress size={14} color='inherit' />
            )}
            {!isSaveButtonLoading && 'Salvar'}
          </Button>
        </Box>
      </DialogActions>

      <Dialog
        open={isDeleteGroupModalOpen}
        onClose={() => {
          setIsDeleteGroupModalOpen(false)
          setIsSelectedRemoveResponsibleFromStoresCheckbox(false)
        }}
      >
        <DialogTitle style={{ paddingTop: 22 }} disableTypography>
          <Typography variant='h4'>Excluir Regional</Typography>
          <IconButton
            aria-label='close'
            onClick={() => setIsDeleteGroupModalOpen(false)}
            style={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500]
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography>
            Você tem certeza que você deseja excluir a regional
            <b> {groupName}</b>?
          </Typography>
          {storesToRemoveResponsibleModal.length > 0 && (
            <Typography>
              Caso deseje remover o acesso de
              <b> {selectedResponsible.name?.complete}</b> das lojas abaixo,
              marque a caixa de seleção.
              <br />
              <FormControlLabel
                control={
                  <Checkbox
                    disableRipple
                    color='primary'
                    checked={isSelectedRemoveResponsibleFromStoresCheckbox}
                    onClick={() =>
                      setIsSelectedRemoveResponsibleFromStoresCheckbox(
                        previousValue => !previousValue
                      )
                    }
                  />
                }
                label='Desvincular totalmente o usuário das lojas'
                style={{ marginLeft: '8px' }}
              />
              <ul style={{ marginLeft: '36px' }}>
                {storesToRemoveResponsibleModal.map(store => (
                  <li key={store._id}>
                    <b>{store.name}</b>
                  </li>
                ))}
              </ul>
            </Typography>
          )}
          <Typography style={{ marginTop: '12px' }}>
            Essa ação não poderá ser desfeita
          </Typography>
        </DialogContent>

        <DialogActions
          style={{
            paddingLeft: '24px',
            paddingRight: '24px'
          }}
        >
          <ButtonUI
            variant='text'
            onClick={() => {
              setIsDeleteGroupModalOpen(false)
              setIsSelectedRemoveResponsibleFromStoresCheckbox(false)
            }}
            disabled={loading}
          >
            Cancelar
          </ButtonUI>
          <ButtonUI
            variant='text'
            onClick={handleRemoveGroup}
            disabled={loading}
            style={{ color: 'red' }}
          >
            {loading && <CircularProgress size={14} color='inherit' />}
            {!loading && 'Excluir'}
          </ButtonUI>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isConfirmEditGroupModalOpen}
        onClose={() => {
          setIsConfirmEditGroupModalOpen(false)
          setIsSelectedRemoveResponsibleFromStoresCheckbox(false)
        }}
      >
        <DialogTitle style={{ paddingTop: 22 }} disableTypography>
          <Typography variant='h4'>Editar Regional</Typography>
          <IconButton
            aria-label='close'
            onClick={() => setIsConfirmEditGroupModalOpen(false)}
            style={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500]
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {storesToShowInModal.length > 0 && (
            <Typography
              style={{
                marginBottom:
                  storesToRemoveResponsibleModal.length > 0 && '12px'
              }}
            >
              <span style={{ fontSize: 16, lineHeight: 1.75 }}>
                Vincular <b>{selectedResponsible.name?.complete}</b> às lojas.
              </span>
              <span
                style={{
                  fontSize: 14,
                  display: 'block',
                  marginBottom: 6,
                  color: '#8d9091'
                }}
              >
                O usuário <b> {selectedResponsible.name?.complete}</b> não está
                vinculado em todas as lojas dessa Regional. Para definir ele
                como responsável da Regional é preciso vincular ele às lojas:
              </span>
              <ul style={{ marginLeft: '30px' }}>
                {storesToShowInModal.map(store => (
                  <li key={store._id}>
                    <b>{store.name}</b>
                  </li>
                ))}
              </ul>
            </Typography>
          )}

          {storesToRemoveResponsibleModal.length > 0 && (
            <Typography
              style={{
                marginTop: storesToShowInModal.length > 0 && 24
              }}
            >
              {hasChangedResponsible ? (
                <>
                  <span style={{ fontSize: 16, lineHeight: 1.75 }}>
                    Remover <b>{currentResponsible?.name?.complete}</b> da
                    regional.
                  </span>
                  <span
                    style={{ fontSize: 14, display: 'block', color: '#8d9091' }}
                  >
                    O usuário <b> {currentResponsible?.name.complete}</b> não
                    será mais responsável pela regional. Se também deseja
                    remover o acesso dele nas lojas abaixo, marque a caixa de
                    seleção.
                  </span>
                </>
              ) : (
                <>
                  <span style={{ fontSize: 16, lineHeight: 1.75 }}>
                    Remover <b>{currentResponsible?.name?.complete}</b> das
                    lojas.
                  </span>
                  <span
                    style={{ fontSize: 14, display: 'block', color: '#8d9091' }}
                  >
                    Se também deseja remover o acesso de{' '}
                    <b> {currentResponsible?.name.complete}</b> nas lojas
                    abaixo, marque a caixa de seleção.
                  </span>
                </>
              )}
              <FormControlLabel
                control={
                  <Checkbox
                    disableRipple
                    color='primary'
                    checked={isSelectedRemoveResponsibleFromStoresCheckbox}
                    onClick={() =>
                      setIsSelectedRemoveResponsibleFromStoresCheckbox(
                        previousValue => !previousValue
                      )
                    }
                  />
                }
                label='Desvincular totalmente o usuário das lojas'
                style={{ marginLeft: '0px' }}
              />
              <ul style={{ marginLeft: '30px' }}>
                {storesToRemoveResponsibleModal.map(store => (
                  <li key={store._id}>
                    <b>{store.name}</b>
                  </li>
                ))}
              </ul>
            </Typography>
          )}
        </DialogContent>

        <DialogActions
          style={{
            paddingLeft: '24px',
            paddingRight: '24px'
          }}
        >
          <ButtonUI
            variant='text'
            onClick={() => {
              setIsConfirmEditGroupModalOpen(false)
              setIsSelectedRemoveResponsibleFromStoresCheckbox(false)
            }}
            disabled={loading}
          >
            Cancelar
          </ButtonUI>
          <ButtonUI
            variant='text'
            onClick={handleSaveEditGroup}
            disabled={loading}
            style={{
              backgroundColor: palette.primary.main,
              color: palette.white
            }}
          >
            {loading && <CircularProgress size={14} color='inherit' />}
            {!loading && 'Salvar'}
          </ButtonUI>
        </DialogActions>
      </Dialog>
    </Dialog>
  )
}
